import React from 'react';

import DeveloperPage from '../../styles/templates/DeveloperPage';
import SupportForm from './SupportForm';
import PageHeader from '../../styles/templates/PageHeader';

type PropsType = {
  path?: string;
  default?: boolean;
};

const SupportPage: React.FC<PropsType> = () => (
  <DeveloperPage>
    <PageHeader
      title="Support"
      subtitle="To request support from our team, please complete the form below with details of your request and the best way
        for us to contact you"
    />

    <SupportForm />
  </DeveloperPage>
);

export default SupportPage;
